import "./RadioButton.less";

import * as React from "react";

const RadioButton = props => {
	const { id, disabled, name, value, checked, onClick, children } = props;

	return (
		<div className="radio-group">
			<label>
				<span className="radio-button">
					<input id={id} name={name} type="radio" value={value} checked={checked} onChange={onClick} disabled={disabled} />
					<span className="radio" />
				</span>
				<span className="label">{children}</span>
			</label>
		</div>
	);
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/inputs/RadioButton/RadioButton.js